export const state = {
  sales: [],
  sale_items: [
    {
      product_id: "",
      truck_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remark: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/sales/state.js